import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_MasterDetail',
  name: 'CDS_VF_MasterDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'マスタ管理詳細',
      controller: 'CDS_CTR_MasterDetail',
    },
    guardRules: [user],
  },
};
